import * as React from 'react';

import classnames from 'classnames';

import { type StepperType } from '../../Stepper';

import styles from './StepTail.module.scss';

export type StepTailProps = {
    type?: StepperType;
    active?: boolean;
};

export const StepTail = ({ type = 'number', active }: StepTailProps) => {
    return (
        <div
            className={classnames(styles.tail, styles[type], {
                [styles.active]: active
            })}
        />
    );
};
